import { useQuery } from 'react-query';
import apiCalls from '../../utils/apiCalls';

export function usePushNotifications(params) {
  const { data, ...rest } = useQuery('pushNotifications', () =>
    apiCalls.getPushNotifications(params).then(({ data: { pushNotifications, totalCount } }) => ({
      pushNotifications,
      totalCount,
    }))
  );
  return { result: data, ...rest };
}
